import { DefaultOptionType } from "antd/es/select";
import { InputSearchFieldDef } from "../../../components/common/AdminSearchFilter";
import {
    getNiveauInterneAdulteOptions,
    getNiveauInterneEnfantOptions,
    getNiveauOptions,
    getReinscriptionFilterOptions,
    getStatutInscriptionOptions,
} from "../../../components/common/commoninputs";

export interface InscriptionFilterConfig {
    /** Filtres toujours affichés sur les deux écrans. */
    staticFilters: InputSearchFieldDef[];
    /** Filtres que l'utilisateur peut ajouter/retirer à la demande. */
    optionalFilters: InputSearchFieldDef[];
}

/**
 * Définition centralisée des filtres de recherche d'inscriptions, partagée
 * entre la vue desktop et la vue mobile pour éviter toute divergence.
 *
 * Set statique volontairement minimal (période, prénom, nom, statut,
 * réinscription) ; les filtres plus spécifiques sont optionnels et ajoutés
 * à la demande via « + Ajouter un filtre ».
 */
export const getInscriptionFilterConfig = (
    application: string,
    periodesOptions?: DefaultOptionType[],
): InscriptionFilterConfig => {
    const isEnfant = application === "COURS_ENFANT";

    const staticFilters: InputSearchFieldDef[] = [
        { name: "idPeriode", libelle: "Période", inputType: "Select", selectOptions: periodesOptions },
        { name: "prenom", libelle: "Prénom", inputType: "InputText" },
        { name: "nom", libelle: "Nom", inputType: "InputText" },
        { name: "statut", libelle: "Statut", inputType: "Select", selectOptions: getStatutInscriptionOptions() },
        { name: "reinscription", libelle: "Réinscription", inputType: "Select", selectOptions: getReinscriptionFilterOptions() },
    ];

    const optionalFilters: InputSearchFieldDef[] = [
        { name: "noInscription", libelle: "N° inscription", inputType: "InputText" },
        ...(isEnfant
            ? [{ name: "niveau", libelle: "Niveau", inputType: "SelectTags", selectOptions: getNiveauOptions() } as InputSearchFieldDef]
            : []),
        {
            name: "niveauInterne",
            libelle: "Niveau interne",
            inputType: "SelectTags",
            selectOptions: isEnfant ? getNiveauInterneEnfantOptions() : getNiveauInterneAdulteOptions(),
        },
        { name: "telephone", libelle: "Téléphone", inputType: "InputText" },
        {
            name: "dateInscription",
            libelle: "Date inscription",
            inputType: "Date",
            tooltip: "Rechercher les inscriptions reçues à partir du",
        },
    ];

    return { staticFilters, optionalFilters };
};
